import Vue from 'vue'
import VueMasonry from 'vue-masonry-css'
import PortalVue from 'portal-vue'
import VTooltip from 'v-tooltip'

Vue.use(VueMasonry);
Vue.use(PortalVue);
Vue.use(VTooltip);
